var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadiant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 42,
    viewBox: "0 0 27 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2954 41H6.03819C4.1819 38.6086 3.14121 37.2679 1.28491 34.8764V7.12356C3.14121 4.73214 4.1819 3.39143 6.03819 1H21.2954C23.1517 3.39143 24.1924 4.73214 26.0487 7.12356V34.8764C24.1924 37.2679 23.1517 38.6086 21.2954 41Z",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.8372 37.1765H7.49706C5.99568 35.2423 5.15397 34.1579 3.65259 32.2237V9.777C5.15397 7.84279 5.99568 6.75842 7.49706 4.82422H19.8372C21.3385 6.75842 22.1803 7.84279 23.6816 9.777V32.2237C22.1803 34.1579 21.3385 35.2423 19.8372 37.1765Z",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.665 31.4821H9.66874C8.69583 30.2287 8.15042 29.5261 7.17773 28.2727V13.7277C8.15065 12.4743 8.69605 11.7716 9.66874 10.5186H17.665C18.6379 11.7719 19.1833 12.4746 20.1562 13.7277V28.2727C19.1833 29.5261 18.6379 30.2287 17.665 31.4821Z",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.03857 1.00024L9.66895 10.5185",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.2956 40.9999L17.6652 31.4819L13.6671 40.9999L9.66895 31.4819L6.03857 40.9999",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.665 31.482L26.0487 34.8767L20.1561 28.2726L26.0487 21.0001L20.1561 13.7276L26.0487 7.12381L17.665 10.5185L21.2954 1.00024",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.6688 31.482L1.28516 34.8767L7.1778 28.2726L1.28516 21.0001L7.1778 13.7276L1.28516 7.12381L9.6688 10.5185L13.6669 1.00024L17.665 10.5185",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiant);
export default __webpack_public_path__ + "static/media/radiant.e4928dbfec05182e0c303ab0ce0db769.svg";
export { ForwardRef as ReactComponent };